module.exports = __webpack_public_path__ + "static/latifa-385c6d2d9e1cd412d02fe0dc32ad1845.png";